import { useFormik } from 'formik'
import * as Yup from 'yup'

import {
  START_DATE_QUARTER_DATA,
  TODAY_DATE,
} from '../../../../common/constants'

//TODO: Add some validation
// postalCodeFrom < postalCodeTo
const validationSchema = Yup.object().shape({
  statusCode: Yup.array(Yup.string()).ensure(),
  clientCenterCode: Yup.string(),
  postalCodeSource: Yup.string(),
  postalCodeFrom: Yup.string(),
  postalCodeTo: Yup.string(),
  originPostalCode: Yup.string(),
  destinPostalCode: Yup.string(),
  country: Yup.string(),
  serviceType: Yup.object().shape({ code: Yup.string(), label: Yup.string() }),
  dateFrom: Yup.string(),
  dateTo: Yup.string(),
})

const getInitialValues = (initialFilters, countries) => ({
  statusCode: initialFilters.statusCode ?? [],
  clientCenterCode: initialFilters.clientCenterCode ?? '',
  postalCodeSource: initialFilters.postalCodeSource ?? 'origin',
  postalCodeFrom: initialFilters.postalCodeFrom ?? '',
  postalCodeTo: initialFilters.postalCodeTo ?? '',
  originPostalCode: initialFilters.originPostalCode ?? '',
  destinPostalCode: initialFilters.destinPostalCode ?? '',
  country: countries.find(opt => opt.code === initialFilters.country)?.code ?? initialFilters.country ?? 'ES',
  serviceType: null,
  dateFrom: initialFilters.dateFrom ?? START_DATE_QUARTER_DATA,
  dateTo: initialFilters.dateTo ?? TODAY_DATE,
})

const getParamFilters = values => {
  const filters = {}

  for (const [key, value] of Object.entries(values)) {
    if ((key === 'country' || key === 'serviceType') && value?.code)
      filters[key] = value.code
    else if (value !== '') filters[key] = value
    //TODO: delete previous filters if now its value is null ??
  }
  return filters
}

const useShippingsFiltersForm = (applyFilters, initialFilters, countries) => {
  const formik = useFormik({
    validationSchema,
    initialValues: getInitialValues(initialFilters, countries),
  })

  const handleSubmit = ev => {
    ev.preventDefault()
    const filters = getParamFilters(formik.values)
    applyFilters(filters)
    formik.handleReset()
  }

  return { formik, handleSubmit }
}

export default useShippingsFiltersForm
